import {
  Box,
  Button
} from "@mui/material"
import { makeStyles } from "@mui/styles"
import {
  NoPhotographyRounded,
  // ShoppingCartCheckout // TBI - Keeping it until we implement the cart.
} from "@mui/icons-material"
import {
  useState,
  useEffect
} from "react"
import {
  useTheme,
  styles,
  stylesDark,
  Styles
} from "../providers/theme"
import useWidth from "../hooks/window"
import { PropertyArea } from "./propertyArea"
import { SparePart, useSpareParts } from "../providers/spareParts"

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function ShopItemCard({
  sparePart,
  displayMode,
  currencyIcons,
}: {
  sparePart: SparePart,
  displayMode: string,
  currencyIcons: Record<string, string>
}) {
  const {mode} = useTheme()
  const {setSelectedItem} = useSpareParts()
  const classesLight = useStylesLight(styles)
  const classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark
  const width = useWidth()

  const [isValidImage, setIsValidImage] = useState(false);

  useEffect(() => {
    setIsValidImage(true)
  }, [sparePart.Picture])

  return (
    <>
      {
        displayMode === 'grid' ?
          <Box className={classes.userCard}>
            <div
              style={{
                width: "100%",
                marginInline: "1em",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
            </div>
            <Box className={classes.userPhotoContainer}>
              {
                !!sparePart ?
                  isValidImage ? (
                    <img
                      referrerPolicy="no-referrer"
                      className={classes.userPhoto}
                      src={sparePart?.Picture}
                      onError={(e) => {
                        setIsValidImage(false);
                      }}
                      alt={sparePart!.Description !== '' ? sparePart!.Description : "Unknown"}
                    />
                  ) : (
                    <NoPhotographyRounded fontSize="large" />
                  )
                :
                  "loading"
              }
            </Box>
            <PropertyArea
              property={"Item"}
              content={`${sparePart.Item || "Unknown"}`}
              classes={{
                container:  classes['propertyArea'],
                property: classes['propertyAreaProperty'],
                content: classes['propertyAreaContent']
              }}

            />
            <PropertyArea
              property={"Description"}
              content={`${sparePart.Description || "Unknown"}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: classes['propertyAreaProperty'],
                content: classes['propertyAreaContent']
              }}

            />
            <PropertyArea
              property={"Model and version"}
              content={`${sparePart.ModelAndVer}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: classes['propertyAreaProperty'],
                content: classes['propertyAreaContent']
              }}
            />
            <PropertyArea
              property={"Currency"}
              content={`${sparePart.Currency || "N/A"}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: classes['propertyAreaProperty'],
                content: classes['propertyAreaContent']
              }}
            />
            <PropertyArea
              property={"Price"}
              content={`${sparePart.Price || "N/A"}`}
              classes={{
                container: `${classes['propertyArea']} ${classes['propertyAreaSmallTopMargin']}`,
                property: classes['propertyAreaProperty'],
                content: classes['propertyAreaContent']
              }}
            />
            <Box
              sx={{
                  position: "relative",
                  width: "100%"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  className={classes.userCardButtonOpen}
                  onClick={() => {
                    setSelectedItem(sparePart)
                  }}
                >
                  Open
                </Button>
              </Box>
              {/* <Button
                variant="contained"
                className={classes.shopCardButtonCart}
                size="small"
                sx={{
                  position: "absolute",
                  backgroundColor: "blue",
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <ShoppingCartCheckout fontSize="small"/>
              </Button> */}
            </Box>
          </Box>
        :
          <Box className={classes.userRow}>
            <Box
              className={classes.shopItemPhotoContainerRow}
              sx={{
                border: `.18em solid ${sparePart?.State.toLowerCase()}`
              }}
            >
              {
                !!sparePart ?
                  isValidImage ? (
                    <img
                      referrerPolicy="no-referrer"
                      className={classes.userPhoto}
                      src={sparePart?.Picture}
                      onError={(e) => {
                        setIsValidImage(false);
                      }}
                      alt={sparePart?.Description !== '' ? sparePart.Description : "Unknown"}
                    />
                  ) : (
                    <NoPhotographyRounded fontSize="large" />
                  )
                :
                  "loading"
              }
            </Box>
            <PropertyArea
              property={"Item"}
              content={`${sparePart.Item || ""}`}
              classes={{
                container: classes['shopItemRowPropertyAreaPartNr'],
                content: classes['userRowPropertyAreaContent']
              }}
            />
            <PropertyArea
              property={"Description"}
              content={`${sparePart.Description || ""}`}
              classes={{
                container: classes['shopItemRowPropertyAreaDescription'],
                content: classes['userRowPropertyAreaContent']
              }}
            />
            <PropertyArea
              property={"Price"}
              content={`${sparePart.Price || ""} ${currencyIcons[sparePart.Currency] || ""}`}
              classes={{
                container: classes['shopItemRowPropertyAreaPrice'],
                content: classes['userRowPropertyAreaContent']
              }}
            />
            <PropertyArea
              property={"Price"}
              content={`${sparePart.DiscountedPrice || ""} ${currencyIcons[sparePart.Currency] || ""}`}
              classes={{
                container: classes['shopItemRowPropertyAreaDiscounted'],
                content: classes['userRowPropertyAreaContent']
              }}
            />
            <Button
              variant="contained"
              className={classes.shopItemRowButtonOpen}
              onClick={() => {
                setSelectedItem(sparePart)
              }}
              size="small"
              sx={{
                fontSize: `${width > 750 ? '.8em' : '.7em'}`,
              }}
            >
              Open
            </Button>
            {/* <Button
              variant="contained"
              color="error"
              className={classes.shopItemRowButtonCart}
              size="small"
              startIcon={
                <ShoppingCartCheckout fontSize="small"
                  />}
              sx={{
                fontSize: `${width > 750 ? '.3em' : '.3em'}`
              }}
            >
            </Button> */}
          </Box>
      }
    </>
  )
}